import { fetchEndpoint } from '../server/network';

//权限列表
export function getPermissionsList(params) {
  return fetchEndpoint(
    '/permissions',
    'GET',
    params
  )
}

//保存权限
export function putPermissions(params) {
  return fetchEndpoint(
    '/roles/'+ params.id +'/permissions',
    'PUT',
    params
  )
}

//角色列表
export function getRoleList(params) {
  return fetchEndpoint(
    '/roles',
    'GET',
    params
  )
}

//创建角色
export function getCreate(params) {
  return fetchEndpoint(
    '/roles',
    'POST',
    params
  )
}

//角色详情
export function getDetail(params) {
  return fetchEndpoint(
    '/roles/'+ params.id,
    'GET',
  )
}

//编辑角色
export function getEdit(params) {
  return fetchEndpoint(
    '/roles/'+ params.id,
    'PUT',
    params
  )
}

//删除角色
export function getDelete(params) {
  return fetchEndpoint(
    '/roles/'+ params.id,
    'DELETE',
  )
}

//店铺管理员列表
export function getShopRoleList(params) {
  return fetchEndpoint(
    '/owner',
    'GET',
    params
  )
}

//店铺管理员详情
export function getShopRoleDetail(params) {
  return fetchEndpoint(
    '/owner/'+ params.id,
    'GET',
  )
}

//创建店铺管理员
export function getShopRoleCreate(params) {
  return fetchEndpoint(
    '/owner',
    'POST',
    params
  )
}

//编辑店铺管理员
export function getShopRoleEdit(params) {
  return fetchEndpoint(
    '/owner/'+ params.id,
    'PUT',
    params
  )
}

//删除店铺管理员
export function getShopDelete(params) {
  return fetchEndpoint(
    '/owner/'+ params.id,
    'DELETE',
  )
}

//获取账号信息
export function getMeDetail(params) {
  return fetchEndpoint(
    '/accounts/me',
    'GET',
  )
}

//编辑账号信息
export function getMeEdit(params) {
  return fetchEndpoint(
    '/accounts/me',
    'PUT',
    params
  )
}


